import { AnalysisDetailsController } from '../components/AnalysisDetails/AnalysisDetailsController';
import AnalysisDetailsView from '../components/AnalysisDetails/AnalysisDetailsView.html';
const ANALYSIS_DETAILS_ID = 'right-sidebar';
const CONTROLLER_ALIAS = '$ctrl';
export class AnalysisDetailsProcessor {
    static $inject = ['$document', 'SidebarContentService'];
    constructor($document, SidebarContentService) {
        'ngInject';
        this.$document = $document;
        this.SidebarContentService = SidebarContentService;
    }
    open(analysis) {
        return this.SidebarContentService.showSidebar({
            controller: AnalysisDetailsController,
            controllerAs: CONTROLLER_ALIAS,
            template: AnalysisDetailsView,
            appendToElement: this.$document[0].getElementById(ANALYSIS_DETAILS_ID),
            inputs: {
                analysis: analysis,
            },
        });
    }
}
AnalysisDetailsProcessor.$inject = ['$document', 'SidebarContentService'];
